import { Component, OnInit, OnDestroy, AfterViewInit, EventEmitter, Output } from '@angular/core';
import { Http } from "@angular/http";
import { Router }  from '@angular/router';
import { Member } from '../member/member';
import { MemberService } from '../member/member.service';
import * as firebase from 'firebase';
import * as _ from 'underscore';

import tinymce from 'tinymce/tinymce';
import 'tinymce/themes/modern/theme';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/link';
import 'tinymce/plugins/textcolor';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/emoticons';
import 'tinymce/plugins/table';
import 'tinymce/plugins/image';
import 'tinymce/plugins/media';
import 'tinymce/plugins/imagetools';
/**
 * Modules
 */
import { AlertModule } from 'ng2-bootstrap';

//import {DataTableModule} from "angular2-datatable";

@Component({
  selector: 'cef-memberList',
  templateUrl: './message.component.html'
})

export class MessageComponent implements AfterViewInit, OnDestroy, OnInit {
	@Output() onEditorKeyup = new EventEmitter<any>();
	public msgContent;
	public msgTitle;
	public warningMsg = '';
	public currTab = 0;
	public storedMsg = new Array();
	public outMsg = new Array();
	public recievableMem = new Array();
	public sentToMem = new Array();
	public msgType = '一般通訊';
	public msgAction = '';
	public replyTitle = '';
	public currUser = {
		uid:'',
		email:'',
		level:'',
		unit:''
	};
	public allProfile;
	public currMsgId = '';
	public currMsgContent = '';
	public disableTab = true;

	public filterQuery = "";
    public rowsOnPage = 10;
    public sortBy = "sendDate";
    public sortOrder = "desc";

	editor;

	constructor(private http: Http, private router: Router, private memberService: MemberService) {
		
	}

	ngOnInit(): void {
		let db = firebase.database();

		firebase.auth().onAuthStateChanged((user:any) => {
		  if (user) {
		    this.currUser.uid = user.uid;
			//this.currUser.uid = 'fVEPM5dJXtffS1XVNLEbRJxFgR92';
		    this.currUser.email = user.email;
		    db.ref('profile/'+this.currUser.uid).once('value').then(
				(snapshot:any) => {
					if (snapshot.val()){
						let returnVal = snapshot.val();
						this.currUser.level = returnVal.level;
						this.currUser.unit = returnVal.unit;
						this._findRecievable();
					}
				}
			)
		  }
		});	    
    }

    _findRecievable() {
    	let db = firebase.database();
    	//var allProfile;
    	
    	db.ref('profile/').once('value').then(
			(snapshot:any) => {
				if (snapshot.val()){
					this.allProfile = snapshot.val();
					if (this.currUser.level == '0' || this.currUser.level == '1' || this.currUser.level == '2'){
						for (let uid in this.allProfile){
							if (uid == this.currUser.uid) continue;
							if (this.currUser.level == '0' || this.currUser.level == '1'){
								//web admin and admin can sent to add user except himself
								this.recievableMem.push({uid:uid,name:this.allProfile[uid].name,level:this.allProfile[uid].level,unit:this.allProfile[uid].unit});
							} else if (this.currUser.level == '2'){
								//course admin can sent to same unit of member
								if (this.currUser.unit!=this.allProfile[uid].unit) continue;
								this.recievableMem.push({uid:uid,name:this.allProfile[uid].name,level:this.allProfile[uid].level,unit:this.allProfile[uid].unit});
							}
						}
						this.recievableMem = _.sortBy( this.recievableMem, 'level' );
						this.recievableMem = _.sortBy( this.recievableMem, 'unit' );
						this.disableTab = false;
					} else if (this.currUser.level == '3'){
						//teacher can only sent to assigned mmember and its parents
						db.ref('childToParent/').once('value').then(
							(snapshot:any)=>{
								let returnVal = snapshot.val();
								for (let i in returnVal){
									if (returnVal[i][this.currUser.uid] !== undefined) {
										let uid = returnVal[i][this.currUser.uid];
										if (uid == this.currUser.uid) continue;
										this.recievableMem.push({
											uid:uid,
											name:this.allProfile[uid].name,
											level:this.allProfile[uid].level,
											unit:this.allProfile[uid].unit
										});
										break;	
									}
								}
							}
						);
						db.ref('parentToChild/'+this.currUser.uid).once('value').then(
							(snapshot:any)=>{
								let returnVal = snapshot.val();
								for (let i in returnVal){
									if (returnVal[i] == this.currUser.uid) continue;
									this.recievableMem.push({
										uid:returnVal[i],
										name:this.allProfile[returnVal[i]].name,
										level:this.allProfile[returnVal[i]].level,
										unit:this.allProfile[returnVal[i]].unit
									});
								}
								this.recievableMem = _.sortBy( this.recievableMem, 'level' );
								this.recievableMem = _.sortBy( this.recievableMem, 'unit' );
								this.disableTab = false;
							}
						);
					} else if (this.currUser.level == '4'){
						//student can sent to other student under same teacher and his teacher
						db.ref('childToParent/').once('value').then(
							(snapshot:any)=>{
								let returnVal = snapshot.val();
								var teachUid;
								for (let i in returnVal){
									if (teachUid == this.currUser.uid) continue;
									if (returnVal[i][this.currUser.uid] !== undefined) {
										teachUid = returnVal[i][this.currUser.uid];
										this.recievableMem.push({
											uid:teachUid,
											name:this.allProfile[teachUid].name,
											level:this.allProfile[teachUid].level,
											unit:this.allProfile[teachUid].unit
										});
										break;	
									}
								}
								db.ref('parentToChild/'+teachUid).once('value').then(
									(snapshot:any)=>{
										let returnVal = snapshot.val();
										for (let i in returnVal){
											if (returnVal[i] == this.currUser.uid) continue;
											this.recievableMem.push({
												uid:returnVal[i],
												name:this.allProfile[returnVal[i]].name,
												level:this.allProfile[returnVal[i]].level,
												unit:this.allProfile[returnVal[i]].unit
											});
										}
										this.recievableMem = _.sortBy( this.recievableMem, 'level' );
										this.recievableMem = _.sortBy( this.recievableMem, 'unit' );
										this.disableTab = false;
									}
								);
							}
						);
					}					
				}
			}
		)
    }

	ngAfterViewInit() {
		tinymce.init({
		  selector: '#msgEditor',
		  plugins: ['link', 'paste', 'textcolor', 'autolink', 'emoticons', 'table','image', 'media', 'imagetools'],
		  skin_url: '../assets/skins/lightgray',
		  toolbar1: 'undo redo styleselect bold italic alignleft aligncenter alignright bullist numlist outdent indent code',
		  toolbar2: 'emoticons image media link paste forecolor backcolor',
		  paste_data_images: false, 
		  min_height: 200, 
		  setup: editor => {
		    this.editor = editor;
		    editor.on('keyup', () => {
		      const content = editor.getContent();
		      this.onEditorKeyup.emit(content);
		    });
		  },
		});
		tinymce.init({
		  selector: '#replyEditor',
		  plugins: ['link', 'paste', 'textcolor', 'autolink', 'emoticons', 'table','image', 'media', 'imagetools'],
		  skin_url: '../assets/skins/lightgray',
		  toolbar1: 'undo redo styleselect bold italic alignleft aligncenter alignright bullist numlist outdent indent code',
		  toolbar2: 'emoticons image media link paste forecolor backcolor',
		  paste_data_images: false, 
		  min_height: 200, 
		  setup: editor => {
		    this.editor = editor;
		    editor.on('keyup', () => {
		      const content = editor.getContent();
		      this.onEditorKeyup.emit(content);
		    });
		  },
		});
	}

	replyMsg(msgId:string, sendeeId:string, title:string, msgType:string){
		this.msgTitle = '回覆：'+title;
		this.sentToMem = [sendeeId];
		this.replyTitle = this.msgTitle;
		this.msgType = msgType;
		this.msgAction = 'reply';
	}

	sendMsg(){
		this.msgContent = tinymce.activeEditor.getContent();
		if (this.msgContent == '' || this.msgTitle == '' || this.sentToMem.length==0){
			this.warningMsg = '請選擇接收訊息會員，輸入內容及標題！';
			setTimeout(()=>{this.warningMsg = '';},this.memberService.modalDismiss);
			return;
		}
		
		let db = firebase.database();
		db.ref('message/').push({content: this.msgContent}).then(
			(val:any)=>{
				var contentUid = val.key;
				db.ref('memberMsg/'+this.currUser.uid+'/out').push(
					{
						title:this.msgTitle,
						type:this.msgType,
						contentId:contentUid,
						sendDate:(new Date()).toString(),
						sendTo:this.sentToMem
					}
				).then(
					(val:any) => {
						for (let uid in this.sentToMem) {
							db.ref('memberMsg/'+this.sentToMem[uid]+'/in').push(
								{
									title:this.msgTitle,
									type:this.msgType,
									contentId:contentUid,
									sendDate:(new Date()).toString(),
									sendFrom:this.currUser.uid
								}
							)
						}
						this.warningMsg = '訊息已發送！';

						//if (this.msgAction=='reply') {
						//	this.selectTab(1);
						//} else {
							this.selectTab(2);
						//}
						//this.msgAction = '';

						setTimeout(()=>{
							this.warningMsg = '';
							this.msgTitle = '';
							this.sentToMem = [];
						},this.memberService.modalDismiss);
					}
					
				)
			}
		)
		
	}

	ngOnDestroy() {
		tinymce.remove(this.editor);
	}

	selectTab(tabNum:number){
    	this.currTab = tabNum;
    	if (this.currTab == 1){
    		//Get member in message
    		this.storedMsg = [];
    		let db = firebase.database();
    		db.ref('memberMsg/'+this.currUser.uid+'/in/').once('value').then(
    			(value:any)=>{
    				var inMsg = value.val();
    				for (let id in inMsg){
    					var level = '';
    					if (this.allProfile[inMsg[id].sendFrom].level=='0') level = '網站管理員';
    					if (this.allProfile[inMsg[id].sendFrom].level=='1') level = '行政管理員';
    					if (this.allProfile[inMsg[id].sendFrom].level=='2') level = '栽培管理員';
    					if (this.allProfile[inMsg[id].sendFrom].level=='3') level = '導師';
    					if (this.allProfile[inMsg[id].sendFrom].level=='4') level = '正式會員';
    					if (this.allProfile[inMsg[id].sendFrom].level=='5') level = '普通會員';

    					this.storedMsg.push({
    							id:id,
								sendeeId:inMsg[id].sendFrom,
    							sendee:'('+this.allProfile[inMsg[id].sendFrom].unit+')'+level+':'+this.allProfile[inMsg[id].sendFrom].name, 
    							contentId:inMsg[id].contentId,
    							title:inMsg[id].title,
								type:inMsg[id].type?inMsg[id].type:'一般通訊',
								read:inMsg[id].read,
    							sendDate:new Date(inMsg[id].sendDate).getTime()
    						}
    					)
    				}
    			}
    		)
    	} else if (this.currTab == 2){
    		//Get member in message
    		this.storedMsg = [];
    		let db = firebase.database();
    		db.ref('memberMsg/'+this.currUser.uid+'/out/').once('value').then(
    			(value:any)=>{
    				var outMsg = value.val();
    				for (var id in outMsg){
    					var sendTo = '';
    					for(let i in outMsg[id].sendTo){
    						var level = '';
	    					if (this.allProfile[outMsg[id].sendTo[i]].level=='0') level = '網站管理員';
	    					if (this.allProfile[outMsg[id].sendTo[i]].level=='1') level = '行政管理員';
	    					if (this.allProfile[outMsg[id].sendTo[i]].level=='2') level = '栽培管理員';
	    					if (this.allProfile[outMsg[id].sendTo[i]].level=='3') level = '導師';
	    					if (this.allProfile[outMsg[id].sendTo[i]].level=='4') level = '正式會員';
	    					if (this.allProfile[outMsg[id].sendTo[i]].level=='5') level = '普通會員';
    						sendTo += '('+this.allProfile[outMsg[id].sendTo[i]].unit+')'+level+':'+this.allProfile[outMsg[id].sendTo[i]].name+'<br>';
    					}

    					this.storedMsg.push({
    							id:id,
    							sendee:sendTo, 
    							contentId:outMsg[id].contentId,
    							title:outMsg[id].title,
								type:outMsg[id].type?outMsg[id].type:'一般通訊',
    							sendDate:new Date(outMsg[id].sendDate).getTime()
    						}
    					)
    				}
    			}
    		)
    	}
    }

    showMsg(msgContentId:string, msgId:string){
    	if (this.currMsgId == msgContentId) {
    		this.currMsgId = '';
    	} else {
    		this.currMsgId = msgContentId;
    		let db = firebase.database();
    		db.ref('message/'+msgContentId+'/content/').once('value').then(
    			(value:any)=>{
    				this.currMsgContent = value.val()
					//mark self read
					if (this.currTab==1){
						db.ref('memberMsg/'+this.currUser.uid+'/in/'+msgId+'/read').set((new Date()).toString()).then(
							(val:any)=>{
								//update current msg list
								for (var index in this.storedMsg){
									if (this.storedMsg[index].id==msgId){
										this.storedMsg[index].read = new Date().toString();
										break
									}
								}
							}
						)
					}
    			}
    		);



    	}

    }
 
}



// WEBPACK FOOTER //
// C:/Users/noomo/Desktop/project/newCefKid/cefapp2/src/app/webadmin/message.component.ts